import i18n from './i18n.js';

const calendarStringKeys = [
    'calendarLabel',
    'closeDatePicker',
    'focusStartDate',
    'clearDate',
    'clearDates',
    'jumpToPrevMonth',
    'jumpToNextMonth',
    'keyboardShortcuts',
    'showKeyboardShortcutsPanel',
    'hideKeyboardShortcutsPanel',
    'openThisPanel',
    'enterKey',
    'leftArrowRightArrow',
    'upArrowDownArrow',
    'pageUpPageDown',
    'homeEnd',
    'escape',
    'questionMark',
    'selectFocusedDate',
    'moveFocusByOneDay',
    'moveFocusByOneWeek',
    'moveFocusByOneMonth',
    'moveFocustoStartAndEndOfWeek',
    'returnFocusToInput',
    'keyboardNavigationInstructions',
];

const calendarFuncKeys = [
    'chooseAvailableStartDate',
    'chooseAvailableEndDate',
    'chooseAvailableDate',
    'dateIsUnavailable',
    'dateIsSelected',
];

// Maps keys to object containing 'key: string' or 'key: interpolation' pairs
const generateStrings = (keys, i18nPrefix) => keys.reduce((acc, key) => Object.assign(acc, { [key]: i18n.t(`${i18nPrefix}.${key}`) }), {});
const generateInterpolated = (keys, i18nPrefix) =>
    keys.reduce((acc, key) => Object.assign(acc, { [key]: ({ date }) => i18n.t(`${i18nPrefix}.${key}`, { date }) }), {});

export const calendarPhrases = () =>
    Object.assign(generateStrings(calendarStringKeys, 'search:calendar'), generateInterpolated(calendarFuncKeys, 'search:calendar'));
